import React, { useCallback } from "react";
import { useTranslate } from "hooks";
import { Button } from "components";
import {
  useProductOutput,
  useTechnicalDesignInputMode,
  TechnicalDesignInputModes,
} from "stores/product";
import cx from "classnames";
import s from "../../../../ProductConfigurator.module.scss";
import { HeaderTitle } from "../HeaderTitle";
import NiceModal from "@ebay/nice-modal-react";
import { ProductAccessoriesModal } from "components/_Modals/ProductAccessoriesModal/ProductAccessoriesModal";

export const Accessories = () => {
  const technicalDesignInputMode = useTechnicalDesignInputMode();
  const translate = useTranslate();
  const productOutput = useProductOutput();
  const accessoryGroupsNumber =
    productOutput?.product?.accessoryGroups?.length || 0;
  const selectedAccessoriesNumber =
    productOutput?.product?.selectedAccessories?.length || 0;

  const onClick = useCallback(() => {
    NiceModal.show(ProductAccessoriesModal);
  }, []);

  const isDisabled =
    technicalDesignInputMode === TechnicalDesignInputModes.RESULT_LIST;

  return (
    accessoryGroupsNumber > 0 && (
      <div
        data-testid="product-configurator-header_accessories"
        className="d-flex flex-column align-items-start justify-content-center"
      >
        <HeaderTitle
          title={translate.stringOnly("PRODUCT_CONFIGURATOR_ACCESSORIES")}
          subtitle={`${selectedAccessoriesNumber}/${accessoryGroupsNumber} ${translate.stringOnly("PRODUCT_CONFIGURATOR_ACCESSORIES_ATTACHED")}`}
        />
        <div
          className={cx(
            s.headerButtons,
            "d-flex flex-nowrap align-items-center",
          )}
        >
          <div className="d-flex gap-1 align-items-center">
            <Button
              data-testid="product-configurator-view-accessories-btn"
              onClick={onClick}
              color="outline-dark"
              disabled={isDisabled}
            >
              {translate("PRODUCT_CONFIGURATOR_SHOW_ACCESSORIES")}
            </Button>
          </div>
        </div>
      </div>
    )
  );
};
